import { useEffect, type ReactNode } from "react";
import { useAuth } from "./useAuth";
import { useTranslation } from "react-i18next";

export function AuthGuard({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { isLoading, hasAccess, redirectToLogin } = useAuth();

  useEffect(() => {
    if (!isLoading && !hasAccess) redirectToLogin();
  }, [isLoading, hasAccess, redirectToLogin]);

  if (isLoading || !hasAccess) {
    return (
      <div className="bg-background flex min-h-screen items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="border-border-strong border-t-accent h-8 w-8 animate-spin rounded-full border-2" />
          <p className="text-muted text-sm">{t("auth.loading")}</p>
        </div>
      </div>
    );
  }
  return children;
}
